// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatio_root__Mrbm0","container":"AspectRatio_container__Wk9WU"};